<script>
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'
    export let data = {}
    export let incorrectFields = {}
    export let raw = {}
    export let valid = true
    export let style = ''
    export let quiet = false
    export let allRequired = false
    let formData = writable({})
    setContext('formData', formData)
    $: data = Object.fromEntries(
        Object.entries($formData).map(([key, obj]) => {
            return [key, obj.value]
        })
    )
    $: incorrectFields = Object.fromEntries(
        Object.entries($formData).filter(([_, obj]) => {
            let { value, validation, valid, required } = obj
            return !(validation ? valid && !!value : required ? !!value : true)
        })
    )
    $: requiredFields = Object.entries($formData)
        .filter(([_, obj]) => {
            return obj.required
        })
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    $: allRequired = Object.entries(requiredFields).every(([_, x]) => !!x.value)
    $: raw = $formData
    $: valid = Object.values(requiredFields).every((x) => {
        let { validation, valid, value } = x
        return validation ? valid : Boolean(value)
    })
</script>

{#if quiet}
    <slot />
{:else}
    <div {style}>
        <slot />
    </div>
{/if}
